import request from '@/utils/request'
const apiPath = '/meet/meetingImage'
import { downloadBlob } from '@/utils/download'
const sysGoodsApi = {
  /**
   * 新增【会议主图】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  createBatch(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【会议主图】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【会议主图】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【会议主图】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【会议主图】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【会议主图】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '会议主图列表.xlsx'))
  },
}
export default sysGoodsApi
